import { PM_PROVIDERS } from 'common/constants/constants';
import {
  filterFormatter,
  FILTER_TYPES,
  resolveFilterValue
} from 'common/constants/filters';
import _ from 'lodash';
import { capitalizeAll } from 'common/utils/utils';
import { pmIntegrationSelector } from 'state/selectors/sensors-authorizations';
import { useSelector } from 'react-redux';

export const useInitSelectedFilters = ({ issueTypes }) => {
  const pmSensor = useSelector(pmIntegrationSelector);
  const isClubhouse = pmSensor?.sensor_id === PM_PROVIDERS.CLUBHOUSE;

  const createSingleSelectedFiltersObject = config => {
    const issueTypesKeysByName = _.keyBy(issueTypes, 'name');
    const issueTypesSelected = _.get(config, 'issue_types', []).map(issueType =>
      isClubhouse ? capitalizeAll(issueType) : issueType
    );
    const labelsSelected = _.get(config, 'labels', []);
    const fieldsSelected = _.get(config, 'fields', []);
    const customFieldsSelectedObject = fieldsSelected.reduce((acc, item) => {
      return {
        ...acc,
        [item.id]: resolveFilterValue(item.value)
      };
    }, {});
    const originSelectedIssueTypes = issueTypesSelected.map(
      name => issueTypesKeysByName[name]
    );
    return {
      [FILTER_TYPES.ISSUE_TYPES]: filterFormatter[FILTER_TYPES.ISSUE_TYPES](
        originSelectedIssueTypes
      ),
      [FILTER_TYPES.LABEL]: filterFormatter[FILTER_TYPES.LABEL](labelsSelected),
      ...customFieldsSelectedObject
    };
  };

  const initSelectedFilters = PMConfig => {
    const multipleFilters = _.get(PMConfig, 'or_filters', []);

    if (multipleFilters.length) {
      const accumulatedFilters = multipleFilters.map(filters => {
        return createSingleSelectedFiltersObject(filters);
      });

      return [...accumulatedFilters];
    }

    const formattedSelectedFilters =
      createSingleSelectedFiltersObject(PMConfig);
    return [formattedSelectedFilters];
  };

  return { initSelectedFilters };
};
